import {setupPriceMeterTooltips, setupPreload, updateClickover} from './generaleffects-utils';

function updateRating(elem, rating) {
  elem
    .find(".overall-rating span")
    .text(Math.floor(rating[0] * 10) / 10 || "-");
  elem.find(".your-rating span").text(Math.floor(rating[1] * 10) / 10 || "-");
}

function fetchObjectData(item) {
  if (item.data("ajax-requested")) {
    return false;
  }
  var ajaxUrl = item.data("ajax-url");
  var type = item.data("type");
  // fetch popover
  $.ajax({
    url: ajaxUrl,
    data: {},
    type: "GET",
    dataType: "json",
    success: function(resp) {
      // update clickovers html
      // stores nearby
      var clks = item.find("[rel=clickover]"),
        storesClk = clks.filter(".show-stores");

      if (storesClk.length) {
        updateClickover(storesClk, resp.stores_html);
        // update counter
        var count = resp.stores_count;
        storesClk.find(".stores-count").text(count);
        storesClk.find(".stores-label").text("store".pluralize(count));
      }
      // if this is a retailer and it has locations in it
      // then update rating of each location
      var stores = item.find(".savedItem-store");
      if (stores.length) {
        for (let slug in resp.ratings) {
          updateRating(
            stores.filter("[data-slug=" + slug + "]"),
            resp.ratings[slug]
          );
        }
      } else {
        // not a retailer, directly set rating for an item
        updateRating(item, resp.ratings);
      }

      // Setup Fav button listeners
      clks.each(function() {
        var clickover = $(this).data("clickover");
        (content = $(clickover.$tip).find(
          "div.popover-content"
        )), (buttons = content.find(".btn-icon-star"));

        setupFavButtons(buttons, clickover);
      });
    }
  });
  // log that we've sent a request
  item.data("ajax-requested", true);
  return true;
}

function showSaveBtn(elem) {
  $(".savedItem-data-submit").not(elem).slideUp("fast");
  if (typeof elem !== "undefined") {
    elem.slideDown("fast");
  }
}

document.addEventListener('DOMContentLoaded', function() {
  setupPriceMeterTooltips();
  setupPreload(fetchObjectData, ".savedItem");

  $("[rel=tooltip]").tooltip();
  $(".item-types .btn[data-type]").on("click", function() {
    var type = $(this).data("type");
    $("[data-items] [data-type]").each(function() {
      var $this = $(this);
      $this.toggle($this.data("type") === type);
    });
  });
  // Toggle 'Save' data button
  $(".savedItem-data-form textarea").focus(function() {
    showSaveBtn($(this).parents("form").find("input[type=submit]"));
  });

  var priceFmt = /^\$(\d{1,3}(,\d{3})*(\.\d\d)?|\.\d\d)$/;
  $(".savedItem-data-form .price-input").focus(function() {
    showSaveBtn($(this).parents("form").find("input[type=submit]"));
  });

  $(".savedItem-data-submit").on("click", function() {
    // validate form
    var priceValid = true;
    var form = $(this).parents("form");
    var price = $(form).find(".price-input").val();
    if (typeof price !== "undefined") {
      var match = price.match(priceFmt);
      if (match == null) {
        priceValid = false;
      } else {
        price = price.replace("$", "").replace(",", "");
        if (
          isNaN(parseFloat(price)) ||
          !isFinite(price) ||
          price <= 0 ||
          price > 10000
        ) {
          priceValid = false;
        }
      }
      var priceInput = $(form).find(".price-input");
      if (!priceValid) {
        priceInput.tooltip("destroy");
        priceInput
          .tooltip()
          .data("tooltip")
          .tip()
          .find(".tooltip-inner")
          .css("background-color", "#800");
        priceInput.tooltip("show");
        priceInput.addClass("error-input");
        return false;
      } else {
        priceInput.removeClass("error-input");
        priceInput.tooltip("destroy");
      }
    }
  });

  // 'Add note' link visibility (for lines).
  $(".savedItem-lines li").hover(
    function() {
      $(this).find("a.show-notes, a.small-remove").show();
    },
    function() {
      $(this).find("a.show-notes, a.small-remove").hide();
    }
  );

  // Hooking up 'Add note' link (for lines).
  $(".show-notes").on("click", function() {
    form = $(this).siblings(".savedItem-data-form");
    form.slideDown("fast");
    showSaveBtn(form.find(".savedItem-data-submit"));
    return false;
  });

  $(".media-object").hover(
    function() {
      $(this).find("a.small-remove").show();
    },
    function() {
      $(this).find("a.small-remove").hide();
    }
  );
});
